import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { AbstractComponentFlow } from './AbstractComponentFlow';
import { ManifestComponentExtensionType } from '../ManifestStore';
import { OOIManifestBuilder } from '@wix/editor-platform-builder-manifest-adapter';
import { ComponentType } from '@wix/ambassador-devcenter-v1-component/types';
import { DefaultLayout } from '@wix/editor-platform-ooi-metadata-resolver';
var _OOIComponentFlow_brand = /*#__PURE__*/new WeakSet();
export class OOIComponentFlow extends AbstractComponentFlow {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _OOIComponentFlow_brand);
    _defineProperty(this, "type", ManifestComponentExtensionType.OOI);
  }
  // we don't have panels to load for OOI components
  async loadPanels() {}
  async loadManifest(_ref) {
    var _appDataComponent$dat, _appDataComponent$dat2, _appDataComponent$dat3;
    let {
      appDataComponent
    } = _ref;
    if (!appDataComponent.data || !appDataComponent.componentId) {
      return;
    }
    const builderConfigUrl = ((_appDataComponent$dat = appDataComponent.data) == null ? void 0 : _appDataComponent$dat.builderConfigUrl) || '';
    let statics = null;
    let nativeSettingsPanelUrl = null;
    if (builderConfigUrl) {
      // Tier 1: Use existing UMD import
      try {
        statics = await _assertClassBrand(_OOIComponentFlow_brand, this, _importUMD).call(this, builderConfigUrl);
        nativeSettingsPanelUrl = _assertClassBrand(_OOIComponentFlow_brand, this, _getNativeSettingsPanelUrl).call(this, appDataComponent, statics.settingsAction);
      } catch (error) {
        console.warn(`Failed to import UMD for ${appDataComponent.componentId}:`, error);
      }
    } else {
      // Tier 2: Derive from client spec map
      nativeSettingsPanelUrl = _assertClassBrand(_OOIComponentFlow_brand, this, _getNativeSettingsPanelUrl).call(this, appDataComponent);
      statics = _assertClassBrand(_OOIComponentFlow_brand, this, _deriveStaticsFromClientSpecMap).call(this, appDataComponent);
    }
    if (!statics) {
      // Neither approach worked - log and return
      console.warn(`No statics could be derived for ${appDataComponent.componentId}`);
      return;
    }
    const layout = _assertClassBrand(_OOIComponentFlow_brand, this, _getDefaultLayout).call(this, appDataComponent);
    const manifest = new OOIManifestBuilder({
      statics,
      nativeSettingsPanelUrl,
      layout
    }).build({
      isMobile: false
    });
    const compType =
    // @ts-expect-error wrong DM types
    appDataComponent != null && (_appDataComponent$dat2 = appDataComponent.data) != null && _appDataComponent$dat2.componentType && appDataComponent != null && (_appDataComponent$dat3 = appDataComponent.data) != null && _appDataComponent$dat3.refType ?
    // @ts-expect-error wrong DM types
    appDataComponent.data.componentType : appDataComponent.componentId;
    this.manifestStore.setManifest(compType, ManifestComponentExtensionType.OOI, manifest, {
      statics
    });
  }
}
async function _importUMD(url, module) {
  if (module === void 0) {
    module = {
      exports: {}
    };
  }
  // eslint-disable-next-line no-restricted-syntax, no-new-func
  const bundle = (new Function('module', 'exports', await (await fetch(url)).text()).call(module, module, module.exports), module).exports;

  // TODO: add correct language handling
  return bundle.createBuilderConfig({
    siteLanguage: 'en'
  });
}
function _getNativeSettingsPanelUrl(appDataComponent, settingsAction) {
  var _appDataComponent$dat4, _appDataComponent$dat5, _appDataComponent$dat6;
  if (settingsAction != null && settingsAction.hidden || !appDataComponent.data) {
    return null;
  }
  const settingsPanelUrlFromCsm =
  // @ts-expect-error wrong DM types
  ((_appDataComponent$dat4 = appDataComponent.data) == null || (_appDataComponent$dat4 = _appDataComponent$dat4.widgetData) == null ? void 0 : _appDataComponent$dat4.settingsEndpointUrl) || (// @ts-expect-error wrong DM types
  (_appDataComponent$dat5 = appDataComponent.data) == null || (_appDataComponent$dat5 = _appDataComponent$dat5.pageData) == null ? void 0 : _appDataComponent$dat5.settingsEndpointUrl) || (// @ts-expect-error wrong DM types
  (_appDataComponent$dat6 = appDataComponent.data) == null ? void 0 : _appDataComponent$dat6.settingsEndpointUrl);
  return (settingsAction == null ? void 0 : settingsAction.url) || settingsPanelUrlFromCsm || null;
}
function _deriveStaticsFromClientSpecMap(appDataComponent) {
  var _appData$components;
  const appDefId = this.manifestHelpers.getAppDefId(appDataComponent == null ? void 0 : appDataComponent.componentId);
  const appData = this.dm.platform.getAppDataByAppDefId(appDefId ?? '');
  const dashboardComponent = appData == null || (_appData$components = appData.components) == null ? void 0 : _appData$components.find(component => component.type === ComponentType.DASHBOARD);
  const dashboardPageId = dashboardComponent == null ? void 0 : dashboardComponent.componentId;
  return {
    displayName: (appDataComponent == null ? void 0 : appDataComponent.name) ?? '',
    ...(dashboardPageId && {
      dashboardAction: {
        dashboardPageId
      }
    }),
    styleParams: {},
    // Empty for tier 2
    settingsParams: {} // Empty for tier 2
  };
}
function _getDefaultLayout(appDataComponent) {
  var _appDataComponent$dat7;
  // @ts-expect-error wrong DM types
  const compType = appDataComponent == null || (_appDataComponent$dat7 = appDataComponent.data) == null ? void 0 : _appDataComponent$dat7.refType;
  switch (compType) {
    case 'wysiwyg.viewer.components.tpapps.TPAGluedWidget':
      return {
        ...DefaultLayout,
        // controls `pinnable` behavior
        disablePositioning: true
      };
    default:
      return DefaultLayout;
  }
}
//# sourceMappingURL=OOIComponentFlow.js.map